import { render, staticRenderFns } from "./explanation.vue?vue&type=template&id=677b20c4&scoped=true&"
import script from "./explanation.vue?vue&type=script&lang=js&"
export * from "./explanation.vue?vue&type=script&lang=js&"
import style0 from "./explanation.vue?vue&type=style&index=0&id=677b20c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b20c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677b20c4')) {
      api.createRecord('677b20c4', component.options)
    } else {
      api.reload('677b20c4', component.options)
    }
    module.hot.accept("./explanation.vue?vue&type=template&id=677b20c4&scoped=true&", function () {
      api.rerender('677b20c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/explanation.vue"
export default component.exports